export default "__VITE_ASSET__DY_uif1l__"